import React, { useState, useEffect, useCallback } from 'react'
import { TrendingUp, TrendingDown, Minus } from 'lucide-react'
import axios from 'axios'
import { useAccountUpdates } from '@hooks/useAccountUpdates'

const API = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api'

export default function PnLTicker() {
  const [pnl, setPnl] = useState(null)
  const [loading, setLoading] = useState(true)

  // Live updates via WebSocket
  useAccountUpdates({
    onAccountUpdate: useCallback((data) => {
      const val = data.todayPnl ?? data.unrealizedPnl ?? null
      if (val !== null) setPnl(val)
    }, [])
  })

  // Initial REST fetch
  useEffect(() => {
    axios.get(`${API}/accounts/summary`, { withCredentials: true })
      .then(({ data }) => {
        if (data.success && data.data) {
          setPnl(data.data.todayPnl ?? data.data.unrealizedPnl ?? null)
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  if (loading || pnl === null) return null

  const isPositive = pnl > 0
  const isNegative = pnl < 0
  const Icon = isPositive ? TrendingUp : isNegative ? TrendingDown : Minus
  const colorClass = isPositive
    ? 'text-green-600 dark:text-green-400'
    : isNegative
      ? 'text-red-600 dark:text-red-400'
      : 'text-gray-500 dark:text-gray-400'

  return (
    <div
      className={`hidden md:flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${colorClass} bg-gray-100 dark:bg-gray-800`}
      title="Today's P&L"
      aria-label={`Today's profit and loss: ${pnl >= 0 ? '+' : ''}${pnl.toFixed(2)}`}
    >
      <Icon className="w-3.5 h-3.5" aria-hidden="true" />
      <span>{pnl >= 0 ? '+' : ''}{pnl.toFixed(2)}</span>
    </div>
  )
}
